module.exports = __webpack_public_path__ + "img/header-background.3d316ba2.jpg";